import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  class: "flex gap-6 flex-1 min-h-0"
};
const _hoisted_2 = {
  class: "w-72 flex-shrink-0 flex flex-col min-h-0"
};
const _hoisted_3 = {
  class: "list-page-table-panel flex-1 min-h-0 flex flex-col"
};
const _hoisted_4 = {
  class: "px-4 py-3 border-b border-slate-200 bg-slate-50 flex items-center justify-between"
};
const _hoisted_5 = {
  class: "flex-1 overflow-y-auto p-2"
};
const _hoisted_6 = {
  key: 0,
  class: "flex items-center justify-center py-8"
};
const _hoisted_7 = {
  key: 1,
  class: "text-center py-8 text-slate-400 text-sm"
};
const _hoisted_8 = {
  key: 2
};
const _hoisted_9 = {
  class: "flex-1 min-w-0 flex flex-col min-h-0"
};
const _hoisted_10 = {
  class: "list-page-table-panel list-page-table-panel--fill"
};
const _hoisted_11 = {
  class: "filter-bar-field is-wide relative"
};
const _hoisted_12 = ["disabled"];
const _hoisted_13 = {
  key: 0,
  class: "flex items-center gap-2 text-sm text-slate-600"
};
const _hoisted_14 = {
  class: "font-medium text-primary-700"
};
const _hoisted_15 = {
  class: "data-table-shell"
};
const _hoisted_16 = {
  class: "data-table-scroll data-table-scroll--fill"
};
const _hoisted_17 = {
  class: "data-table text-sm min-w-[880px]"
};
const _hoisted_18 = {
  key: 0,
  class: "data-table-row"
};
const _hoisted_19 = {
  key: 1,
  class: "data-table-row"
};
const _hoisted_20 = {
  colspan: "7",
  class: "data-table-empty"
};
const _hoisted_21 = {
  class: "data-table-td font-mono text-slate-600"
};
const _hoisted_22 = {
  class: "data-table-td font-medium text-slate-900"
};
const _hoisted_23 = {
  class: "data-table-td text-slate-500"
};
const _hoisted_24 = {
  class: "data-table-td is-center"
};
const _hoisted_25 = {
  class: "data-table-td is-center text-slate-900"
};
const _hoisted_26 = {
  class: "data-table-td is-center"
};
const _hoisted_27 = {
  class: "data-table-td is-center data-table-sticky-right data-table-sticky-action"
};
const _hoisted_28 = {
  class: "flex items-center justify-center gap-1"
};
const _hoisted_29 = ["onClick"];
const _hoisted_30 = ["onClick"];
import { ref, reactive, computed, onMounted } from 'vue';
import { ElMessage } from 'element-plus';
import { getMaterialCategories, getMaterialDefinitions, createMaterialCategory, updateMaterialCategory, deleteMaterialCategory, createMaterialDefinition, updateMaterialDefinition, deleteMaterialDefinition } from '@/api/customer';
import CategoryTreeNode from './components/CategoryTreeNode.vue';
import AppPagination from '@/components/AppPagination.vue';
import ListPageShell from '@/components/ListPageShell.vue';
import PageFilterBar from '@/components/PageFilterBar.vue';
import CategoryFormModal from './components/CategoryFormModal.vue';
import DefinitionFormModal from './components/DefinitionFormModal.vue';
import DeleteConfirmModal from '@/components/DeleteConfirmModal.vue';

// 分类相关

export default {
  __name: 'MaterialManagement',
  setup(__props) {
    const loadingCategories = ref(false);
    const categoryTree = ref([]);
    const categoryList = ref([]);
    const selectedCategoryId = ref(null);
    const selectedCategoryName = ref('');

    // 类型相关
    const loadingDefinitions = ref(false);
    const definitions = ref([]);
    const total = ref(0);
    const page = ref(1);
    const size = ref(10);
    const searchKeyword = ref('');
    const searchStatus = ref('');

    // 模态框状态
    const showCategoryModal = ref(false);
    const showDefinitionModal = ref(false);
    const showDeleteModal = ref(false);
    const editingCategory = ref(null);
    const editingDefinition = ref(null);

    // 删除配置
    const deleteConfig = reactive({
      type: '',
      id: null,
      title: '',
      message: ''
    });

    // 计算属性
    const totalPages = computed(() => {
      if (!total.value || !size.value) return 1;
      return Math.max(1, Math.ceil(total.value / size.value));
    });

    // 加载分类树
    async function loadCategories() {
      loadingCategories.value = true;
      try {
        const data = await getMaterialCategories();
        categoryTree.value = buildTree(data || []);
        categoryList.value = data || [];
      } catch (error) {
        console.error('加载分类失败:', error);
        ElMessage.error(error.message || '加载分类失败');
      } finally {
        loadingCategories.value = false;
      }
    }

    // 构建树形结构
    function buildTree(list, parentId = null) {
      return list.filter(item => parentId === null ? item.parentId === 0 || item.parentId === null : item.parentId === parentId).sort((a, b) => (a.sort || 0) - (b.sort || 0)).map(item => ({
        ...item,
        children: buildTree(list, item.id)
      }));
    }

    // 加载类型列表
    async function loadDefinitions() {
      if (!selectedCategoryId.value) {
        definitions.value = [];
        total.value = 0;
        return;
      }
      loadingDefinitions.value = true;
      try {
        const params = {
          page: page.value,
          size: size.value,
          categoryId: selectedCategoryId.value,
          keyword: searchKeyword.value || undefined,
          status: searchStatus.value || undefined
        };
        const data = await getMaterialDefinitions(params);
        definitions.value = data?.records || [];
        total.value = Number(data?.total || 0);
      } catch (error) {
        console.error('加载类型列表失败:', error);
        ElMessage.error(error.message || '加载类型列表失败');
      } finally {
        loadingDefinitions.value = false;
      }
    }

    // 选择分类
    function handleCategorySelect(category) {
      selectedCategoryId.value = category.id;
      selectedCategoryName.value = category.name;
      page.value = 1;
      loadDefinitions();
    }

    // 搜索
    function handleSearch() {
      page.value = 1;
      loadDefinitions();
    }

    // 重置搜索
    function resetSearch() {
      searchKeyword.value = '';
      searchStatus.value = '';
      page.value = 1;
      loadDefinitions();
    }

    // 分页
    function handlePageChange(p) {
      page.value = p;
      loadDefinitions();
    }
    function handlePageSizeChange(s) {
      size.value = s;
      page.value = 1;
      loadDefinitions();
    }

    // 分类操作
    function openCategoryModal(category = null) {
      editingCategory.value = category;
      showCategoryModal.value = true;
    }
    function closeCategoryModal() {
      showCategoryModal.value = false;
      editingCategory.value = null;
    }
    async function saveCategory(data) {
      try {
        if (editingCategory.value?.id) {
          await updateMaterialCategory(editingCategory.value.id, data);
          ElMessage.success('修改成功');
        } else {
          await createMaterialCategory(data);
          ElMessage.success('创建成功');
        }
        await loadCategories();
        closeCategoryModal();
      } catch (error) {
        ElMessage.error(error.message || '操作失败');
      }
    }
    function handleDeleteCategory(category) {
      deleteConfig.type = 'category';
      deleteConfig.id = category.id;
      deleteConfig.title = '删除分类';
      deleteConfig.message = `确定要删除分类"${category.name}"吗？删除后该分类下的资料类型将无法正常显示。`;
      showDeleteModal.value = true;
    }

    // 类型操作
    function openDefinitionModal(definition = null) {
      editingDefinition.value = definition;
      showDefinitionModal.value = true;
    }
    function closeDefinitionModal() {
      showDefinitionModal.value = false;
      editingDefinition.value = null;
    }
    async function saveDefinition(data) {
      try {
        if (editingDefinition.value?.id) {
          await updateMaterialDefinition(editingDefinition.value.id, data);
          ElMessage.success('修改成功');
        } else {
          await createMaterialDefinition(data);
          ElMessage.success('创建成功');
        }
        await loadDefinitions();
        closeDefinitionModal();
      } catch (error) {
        ElMessage.error(error.message || '操作失败');
      }
    }
    function handleDeleteDefinition(definition) {
      deleteConfig.type = 'definition';
      deleteConfig.id = definition.id;
      deleteConfig.title = '删除资料类型';
      deleteConfig.message = `确定要删除资料类型"${definition.name}"吗？此操作不可恢复。`;
      showDeleteModal.value = true;
    }

    // 删除确认
    function closeDeleteModal() {
      showDeleteModal.value = false;
    }
    async function confirmDelete() {
      try {
        if (deleteConfig.type === 'category') {
          await deleteMaterialCategory(deleteConfig.id);
          ElMessage.success('删除成功');
          if (selectedCategoryId.value === deleteConfig.id) {
            selectedCategoryId.value = null;
            selectedCategoryName.value = '';
            definitions.value = [];
          }
          await loadCategories();
        } else if (deleteConfig.type === 'definition') {
          await deleteMaterialDefinition(deleteConfig.id);
          ElMessage.success('删除成功');
          await loadDefinitions();
        }
      } catch (error) {
        ElMessage.error(error.message || '删除失败');
      }
      closeDeleteModal();
    }

    // 初始化
    onMounted(() => {
      loadCategories();
    });
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _directive_permission = _resolveDirective("permission");
      return _openBlock(), _createBlock(ListPageShell, {
        fill: ""
      }, {
        header: _withCtx(() => [...(_cache[4] || (_cache[4] = [_createElementVNode("div", {
          class: "list-page-panel is-header-minimal"
        }, [_createElementVNode("div", {
          class: "list-page-heading"
        }, [_createElementVNode("div", {
          class: "list-page-heading-main"
        }, [_createElementVNode("h1", {
          class: "list-page-title"
        }, "素材类型管理"), _createElementVNode("p", {
          class: "list-page-description"
        }, "统一管理素材分类与资料类型，支持查询、添加、编辑和删除")])])], -1)]))]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_cache[6] || (_cache[6] = _createElementVNode("h3", {
          class: "text-sm font-medium text-slate-700"
        }, "资料分类", -1)), _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = $event => openCategoryModal()),
          class: "p-1.5 text-primary-600 hover:bg-primary-50 rounded-lg transition-colors cursor-pointer",
          title: "新增分类"
        }, [...(_cache[5] || (_cache[5] = [_createElementVNode("svg", {
          class: "w-4 h-4",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M12 4v16m8-8H4"
        })], -1)]))])]), _createElementVNode("div", _hoisted_5, [loadingCategories.value ? (_openBlock(), _createElementBlock("div", _hoisted_6, [...(_cache[7] || (_cache[7] = [_createElementVNode("div", {
          class: "w-6 h-6 border-2 border-primary-600 border-t-transparent rounded-full animate-spin"
        }, null, -1)]))])) : categoryTree.value.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_7, " 暂无分类数据 ")) : (_openBlock(), _createElementBlock("div", _hoisted_8, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categoryTree.value, node => {
          return _openBlock(), _createBlock(CategoryTreeNode, {
            key: node.id,
            node: node,
            "selected-id": selectedCategoryId.value,
            onSelect: handleCategorySelect,
            onEdit: $event => openCategoryModal(node),
            onDelete: $event => handleDeleteCategory(node)
          }, null, 8, ["node", "selected-id", "onEdit", "onDelete"]);
        }), 128))]))])])]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createVNode(PageFilterBar, {
          "shell-class": "filter-bar-shell is-embedded",
          "body-class": "filter-bar-body is-panel",
          "show-refresh": true,
          "refresh-loading": loadingDefinitions.value,
          onRefresh: loadDefinitions
        }, {
          searchActionsLeading: _withCtx(() => [_withDirectives((_openBlock(), _createElementBlock("button", {
            disabled: !selectedCategoryId.value,
            onClick: _cache[3] || (_cache[3] = $event => openDefinitionModal()),
            class: "btn-primary disabled:opacity-50 disabled:cursor-not-allowed"
          }, [...(_cache[9] || (_cache[9] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M12 4v16m8-8H4"
          })], -1), _createTextVNode(" 新增类型 ", -1)]))], 8, _hoisted_12)), [[_directive_permission, 'material:definition:add']])]),
          searchActions: _withCtx(() => [_createElementVNode("button", {
            type: "button",
            onClick: handleSearch,
            class: "btn-primary"
          }, "搜索"), _createElementVNode("button", {
            type: "button",
            onClick: resetSearch,
            class: "btn-secondary"
          }, "重置")]),
          extra: _withCtx(() => [selectedCategoryId.value && selectedCategoryName.value ? (_openBlock(), _createElementBlock("div", _hoisted_13, [_cache[10] || (_cache[10] = _createElementVNode("svg", {
            class: "w-4 h-4 text-slate-400",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M5 13l4 4L19 7"
          })], -1)), _cache[11] || (_cache[11] = _createElementVNode("span", null, "当前选中了分类：", -1)), _createElementVNode("span", _hoisted_14, _toDisplayString(selectedCategoryName.value), 1)])) : _createCommentVNode("", true)]),
          default: _withCtx(() => [_createElementVNode("div", _hoisted_11, [_withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => searchKeyword.value = $event),
            type: "text",
            placeholder: "搜索名称/编码...",
            class: "form-search-input form-control-sm w-full",
            onKeyup: _withKeys(handleSearch, ["enter"])
          }, null, 544), [[_vModelText, searchKeyword.value]]), _cache[8] || (_cache[8] = _createElementVNode("svg", {
            class: "absolute left-3 top-2.5 h-4 w-4 text-slate-400",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
          })], -1))]), _createVNode(_component_el_select, {
            modelValue: searchStatus.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => searchStatus.value = $event),
            placeholder: "请选择状态",
            class: "form-select form-control-sm filter-bar-field"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              label: "全部状态",
              value: ""
            }), _createVNode(_component_el_option, {
              label: "启用",
              value: 1
            }), _createVNode(_component_el_option, {
              label: "禁用",
              value: 0
            })]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }, 8, ["refresh-loading"]), _createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_createElementVNode("table", _hoisted_17, [_cache[16] || (_cache[16] = _createElementVNode("thead", {
          class: "data-table-head"
        }, [_createElementVNode("tr", null, [_createElementVNode("th", {
          class: "data-table-th text-left"
        }, "编码"), _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "名称"), _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "别名"), _createElementVNode("th", {
          class: "data-table-th text-center"
        }, "允许多个"), _createElementVNode("th", {
          class: "data-table-th text-center w-20"
        }, "排序"), _createElementVNode("th", {
          class: "data-table-th text-center w-24"
        }, "状态"), _createElementVNode("th", {
          class: "data-table-th text-center data-table-sticky-right data-table-sticky-head data-table-sticky-action"
        }, "操作")])], -1)), _createElementVNode("tbody", null, [loadingDefinitions.value ? (_openBlock(), _createElementBlock("tr", _hoisted_18, [...(_cache[12] || (_cache[12] = [_createElementVNode("td", {
          colspan: "7",
          class: "data-table-empty"
        }, [_createElementVNode("div", {
          class: "flex items-center justify-center gap-2 text-slate-500"
        }, [_createElementVNode("div", {
          class: "w-5 h-5 border-2 border-primary-600 border-t-transparent rounded-full animate-spin"
        }), _createTextVNode(" 加载中... ")])], -1)]))])) : definitions.value.length === 0 ? (_openBlock(), _createElementBlock("tr", _hoisted_19, [_createElementVNode("td", _hoisted_20, " 暂无数据" + _toDisplayString(selectedCategoryId.value ? '，请选择其他分类或新增类型' : '，请先选择分类'), 1)])) : (_openBlock(true), _createElementBlock(_Fragment, {
          key: 2
        }, _renderList(definitions.value, def => {
          return _openBlock(), _createElementBlock("tr", {
            key: def.id,
            class: "data-table-row"
          }, [_createElementVNode("td", _hoisted_21, _toDisplayString(def.code), 1), _createElementVNode("td", _hoisted_22, _toDisplayString(def.name), 1), _createElementVNode("td", _hoisted_23, _toDisplayString(def.nameAlias || '-'), 1), _createElementVNode("td", _hoisted_24, [_createElementVNode("span", {
            class: _normalizeClass(["inline-flex items-center justify-center w-6 h-6 rounded-full text-xs font-medium", def.allowMultiple ? 'bg-green-100 text-green-700' : 'bg-slate-100 text-slate-500'])
          }, _toDisplayString(def.allowMultiple ? '是' : '否'), 3)]), _createElementVNode("td", _hoisted_25, _toDisplayString(def.sort), 1), _createElementVNode("td", _hoisted_26, [_createElementVNode("span", {
            class: _normalizeClass(["status-badge", def.status === 1 ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'])
          }, [_cache[13] || (_cache[13] = _createElementVNode("span", {
            class: "w-1.5 h-1.5 bg-current rounded-full mr-1"
          }, null, -1)), _createTextVNode(" " + _toDisplayString(def.status === 1 ? '启用' : '禁用'), 1)], 2)]), _createElementVNode("td", _hoisted_27, [_createElementVNode("div", _hoisted_28, [_createElementVNode("button", {
            onClick: $event => openDefinitionModal(def),
            class: "table-action-button is-primary",
            title: "编辑",
            "aria-label": "编辑"
          }, [...(_cache[14] || (_cache[14] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
          })], -1)]))], 8, _hoisted_29), _createElementVNode("button", {
            onClick: $event => handleDeleteDefinition(def),
            class: "table-action-button is-danger",
            title: "删除",
            "aria-label": "删除"
          }, [...(_cache[15] || (_cache[15] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
          })], -1)]))], 8, _hoisted_30)])])]);
        }), 128))])])])]), total.value > 0 ? (_openBlock(), _createBlock(AppPagination, {
          key: 0,
          class: "pagination-bridge",
          current: page.value,
          size: size.value,
          total: total.value,
          pages: totalPages.value,
          "page-sizes": [10, 20, 50],
          onPageChange: handlePageChange,
          onSizeChange: handlePageSizeChange
        }, null, 8, ["current", "size", "total", "pages"])) : _createCommentVNode("", true)])]), showCategoryModal.value ? (_openBlock(), _createBlock(CategoryFormModal, {
          key: 0,
          category: editingCategory.value,
          categories: categoryList.value,
          onClose: closeCategoryModal,
          onSave: saveCategory
        }, null, 8, ["category", "categories"])) : _createCommentVNode("", true), showDefinitionModal.value ? (_openBlock(), _createBlock(DefinitionFormModal, {
          key: 1,
          definition: editingDefinition.value,
          "category-id": selectedCategoryId.value,
          onClose: closeDefinitionModal,
          onSave: saveDefinition
        }, null, 8, ["definition", "category-id"])) : _createCommentVNode("", true), showDeleteModal.value ? (_openBlock(), _createBlock(DeleteConfirmModal, {
          key: 2,
          title: deleteConfig.title,
          message: deleteConfig.message,
          onClose: closeDeleteModal,
          onConfirm: confirmDelete
        }, null, 8, ["title", "message"])) : _createCommentVNode("", true)])]),
        _: 1
      });
    };
  }
};